import { baseApi } from "../../redux/baseAPI";

export const reconciliationsApi = baseApi.injectEndpoints({
  tagTypes: ["Reconciliations"],
  endpoints: (builder) => ({
    getReconciliations: builder.query({
      query: (body) => {
        if(body?.pid){
        return {
          url: `/encounters/get_reconciliation.json`,
          method: "GET",
          params: { pid: body.pid, encounter: body.encounter },
        };
      }
      },
      transformResponse: (response, meta, arg) => {
        return (response?.response?.data?.EncounterReconciliation || response?.response?.data);
      },
      providesTags: ["Reconciliations"]
    }),
    markReconciled: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/encounters/save_reconciliation.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid, encounter: body.encounter},
      }),
      transformResponse: (response, meta, arg) => response?.response,
      invalidatesTags:  ["Reconciliations"]
    }),
    markReconciledSecond: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => ({
        url: `/notes/save_reconcile_status.json`,
        method: "POST",
        data: body,
        params: {pid: body.pid}
      })
    }),
    saveSkipSection: builder.mutation({
      query: (body) => ({
        url: `/encounters/save_skip_section.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response?.response,
    }),
  }),
});

export const { useGetReconciliationsQuery, useMarkReconciledMutation, useMarkReconciledSecondMutation, useSaveSkipSectionMutation } = reconciliationsApi;
 
